/* Selection rules shared by the page and its mobile bundle dialog. Prices are cents. */
globalThis.BodyBundleModel = class BodyBundleModel {
  constructor({discountPercent=0,discountCode=''}={}) {
    this.items = new Map();
    this.discountPercent = discountCode ? Math.max(0,Math.min(100,Number(discountPercent)||0)) : 0;
  }
  get count() { return [...this.items.values()].reduce((n,item)=>n+item.quantity,0); }
  get ready() { return this.count>=3 && this.count<=12; }
  get subtotal() { return [...this.items.values()].reduce((n,item)=>n+item.price*item.quantity,0); }
  get total() { return Math.round(this.subtotal*(1-(this.ready?this.discountPercent:0)/100)); }
  validateQuantity(quantity) {
    if(!Number.isInteger(quantity)||quantity<0) throw new Error('Invalid quantity.');
  }
  add(variant,quantity=1) {
    this.validateQuantity(quantity);
    if(!quantity) throw new Error('Invalid quantity.');
    if(!variant.available) throw new Error('This variant is not available.');
    if(!Number.isSafeInteger(Number(variant.id))||!Number.isInteger(variant.price)||variant.price<0) throw new Error('Invalid variant.');
    if(this.count+quantity>12) throw new Error('Maximum 12 products per bundle.');
    const current=this.items.get(String(variant.id));
    this.items.set(String(variant.id),{...variant,quantity:(current?.quantity||0)+quantity});
  }
  setQuantity(id,quantity) {
    this.validateQuantity(quantity);
    const key=String(id),item=this.items.get(key);
    if(!item) throw new Error('Unknown variant.');
    if(this.count-item.quantity+quantity>12) throw new Error('Maximum 12 products per bundle.');
    if(quantity===0) this.items.delete(key);
    else this.items.set(key,{...item,quantity});
  }
  cartItems(bundleId) {
    if(!this.ready) throw new Error('Select at least 3 products.');
    return [...this.items.values()].map(item=>({id:Number(item.id),quantity:item.quantity,properties:{'Bundle':'Body Bundle Builder','_body_bundle':bundleId}}));
  }
};
